import Logo from '../../../images/Logo_Bn.png';
import Letras from '../../../images/Ekk.png';
import { Link } from 'react-router-dom';
import './Navbar.scss';

export default function Nabvar() {
	return (
		<div>
			<nav className='navbar navbar-expand-lg navbar-dark bg-dark'>
				<div className='container'>
					<Link className='navbar-brand d-flex align-items-center' to='/'>
						<img src={Logo} alt='Ekklexia' width='50' height='auto' />
						<img
							src={Letras}
							alt='Ekklexia'
							width='350'
							height='auto'
							className='ps-2 nav-title'
						/>
					</Link>
					<button
						className='navbar-toggler'
						type='button'
						data-bs-toggle='collapse'
						data-bs-target='#navbarSupportedContent'
						aria-controls='navbarSupportedContent'
						aria-expanded='false'
						aria-label='Toggle navigation'
					>
						<span className='navbar-toggler-icon'></span>
					</button>
					<div className='collapse navbar-collapse' id='navbarSupportedContent'>
						<ul className='navbar-nav ms-auto mb-2 mb-lg-0'>
							<li className='nav-item'>
								<a className='nav-link active' aria-current='page' href='/#main-banner'>
									Inicio
								</a>
							</li>
							<li className='nav-item'>
								<a className='nav-link active' href='/#services'>
									Servicios
								</a>
							</li>
							<li className='nav-item'>
								<Link className='nav-link active' to='/nosotros'>
									Nosotros
								</Link>
							</li>
							<li className='nav-item'>
								<a className='nav-link active' href='/#contact'>
									Contacto
								</a>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
	);
}
